import * as authActions from './auth/actions';
import * as apiActions from './api/actions';

export default {
  auth: authActions,
  api: apiActions
};